import { render, staticRenderFns } from "./BankInformation.vue?vue&type=template&id=73a37637"
import script from "./BankInformation.vue?vue&type=script&lang=js"
export * from "./BankInformation.vue?vue&type=script&lang=js"
import style0 from "./BankInformation.vue?vue&type=style&index=0&id=73a37637&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports